(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  // Contact Us submits to BOTH HubSpot and Shopify's native contact handler.
  //
  // HubSpot is the CRM of record, but its Forms API answers 200 even when it
  // discards a property, so a HubSpot-only wiring can lose an enquiry with no
  // trace anywhere. The native POST keeps a copy in the store inbox that staff
  // already watch — the fallback that makes a silent drop survivable.
  //
  // CRITICAL — do NOT preventDefault() and re-submit this form.
  // Shopify Bot Protection injects `h-captcha-response` into this form as part
  // of its own submit handling. Cancelling the native submit and later calling
  // form.submit() skips that handler, so the POST arrives without a valid
  // captcha token and Shopify drops the enquiry — reintroducing the exact
  // silent-loss failure this whole change exists to remove.
  //
  // Instead we let the native submit proceed completely untouched and fire the
  // HubSpot request alongside it with `keepalive`, which lets an in-flight
  // request outlive the page unload that the native POST triggers.
  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      var form = document.getElementById('ContactForm');
      if (!form) return;

      function value(selector) {
        var el = form.querySelector(selector);
        return el ? el.value.trim() : '';
      }

      form.addEventListener('submit', function () {
        // No preventDefault — Shopify's submit continues normally from here.
        if (!window.snlHubSpotSubmit) return;

        window
          .snlHubSpotSubmit(
            {
              // Collected as two fields now, so no name-splitting guesswork.
              firstname: value('#ContactForm-firstname'),
              lastname: value('#ContactForm-lastname'),
              email: value('#ContactForm-email'),
              phone: value('#ContactForm-phone'),
              message: value('#ContactForm-body'),
            },
            'contact',
            { keepalive: true }
          )
          // Nothing to show the customer: the page is already navigating to
          // Shopify's own confirmation, and the emailed copy is the safety net.
          .catch(function () {});
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snl-announcement"]) return;
  try {
    
  (function () {
    var strip = document.getElementById('snl-announcement');
    if (!strip) return;
    var close = strip.querySelector('[data-snl-announcement-close]');
    if (!close) return;

    close.addEventListener('click', function () {
      try {
        sessionStorage.setItem('snl-announcement-dismissed', '1');
      } catch (e) {
        /* private mode — dismiss for this page only */
      }
      strip.classList.add('snl-announcement--dismissing');
      strip.addEventListener(
        'transitionend',
        function () {
          strip.classList.add('snl-announcement--hidden');
          // Sticky header just moved up — let listeners re-measure
          // (snl-header keeps --snl-header-bottom in sync on resize).
          window.dispatchEvent(new Event('resize'));
        },
        { once: true }
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snl-footer"]) return;
  try {
    
  // Shopify's customer form reloads the page at the top after submit; bring
  // the newsletter band back into view so the success/error status is seen.
  (() => {
    const band = document.getElementById('snl-footer-newsletter');
    if (!band) return;
    const posted = new URLSearchParams(window.location.search).has('customer_posted');
    const failed = band.querySelector('.snl-footer__nl-error');
    if (posted || failed) band.scrollIntoView({ block: 'center' });
  })();

  // Newsletter also submits to HubSpot, alongside Shopify's native POST.
  //
  // Shopify-only signups reached HubSpot through the customer sync as
  // NON-marketing contacts, so people who opted in could not be emailed. The
  // HubSpot submission carries their consent explicitly: `communications`
  // subscribes them to subscription type 2741794967 — the one the HubSpot
  // form's own consent checkbox uses (read from its render definition).
  //
  // Same rules as Contact Us: never preventDefault() here — Shopify Bot
  // Protection must run its own submit handling — and fire HubSpot with
  // `keepalive` so the request outlives the page navigation.
  (() => {
    const form = document.getElementById('SnlFooterNewsletter');
    if (!form) return;

    const SUBSCRIPTION_TYPE_ID = 2741794967;

    form.addEventListener('submit', () => {
      if (!window.snlHubSpotSubmit) return;

      const email = form.querySelector('input[name="contact[email]"]');
      const checkbox = form.querySelector('input[name="contact[accepts_marketing]"]');
      if (!email || !email.value.trim()) return;

      // The text recorded is the sentence the visitor actually ticked, not
      // HubSpot's own label, which our footer never shows.
      const consentText = checkbox
        ? checkbox.closest('label').textContent.replace(/\s+/g, ' ').trim()
        : '';

      window
        .snlHubSpotSubmit({ email: email.value }, 'newsletter', {
          keepalive: true,
          legalConsentOptions: {
            consent: {
              consentToProcess: true,
              text: consentText,
              communications: [
                {
                  value: !!(checkbox && checkbox.checked),
                  subscriptionTypeId: SUBSCRIPTION_TYPE_ID,
                  text: consentText,
                },
              ],
            },
          },
        })
        // The page is already navigating to Shopify's confirmation; the
        // Shopify customer record is the fallback if this is lost.
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snl-header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.snl-header-wrapper');
    if (!header) return;
    var sticky = header.classList.contains('snl-header-wrapper--sticky');

    // Exact copy of the SNL site's scroll-direction handler (header.ts
    // onScroll): every scroll event handled directly, hide only while moving
    // DOWN past the 80px threshold, reveal on ANY upward delta, no rAF gate.
    var lastY = window.scrollY || 0;
    var HIDE_THRESHOLD = 80; // site: hideThreshold

    function setPanelTop() {
      var rect = header.getBoundingClientRect();
      header.style.setProperty('--snl-header-bottom', Math.max(0, rect.bottom) + 'px');
    }

    function onScroll() {
      var y = window.scrollY || 0;
      var delta = y - lastY;

      if (y > 8) {
        header.classList.add('is-scrolled'); // site: atTop = y <= 8
      } else {
        header.classList.remove('is-scrolled');
      }

      if (sticky) {
        var menuOpen = header.querySelector('.snl-header__mobile-toggle[open]');
        if (menuOpen) {
          header.classList.remove('is-hidden');
        } else if (y > HIDE_THRESHOLD && delta > 0) {
          header.classList.add('is-hidden');
        } else if (delta < 0) {
          header.classList.remove('is-hidden');
        }
      }

      setPanelTop();
      lastY = y;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setPanelTop);

    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snl-main-collection"]) return;
  try {
    
  /* Enhance Dawn's price facet (two text inputs) with a dual-knob range slider.
     The two inputs stay as the small editable fields and remain the source of
     truth Dawn filters on; the slider writes into them and dispatches change so
     AJAX filtering fires on release. Two-way: typing in a field moves the knob.
     Re-runs after facets.js re-renders the sidebar (MutationObserver). */
  (function () {
    var root, observer;

    function num(s) {
      var n = parseFloat(String(s == null ? '' : s).replace(/[^0-9.]/g, ''));
      return isNaN(n) ? null : n;
    }

    function build(priceEl, minInput, maxInput) {
      var ceil = num(minInput.getAttribute('data-max')) || num(maxInput.getAttribute('data-max'));
      if (!ceil) return;

      var wrap = document.createElement('div');
      wrap.className = 'snl-price-slider';
      wrap.innerHTML =
        '<div class="snl-price-slider__track"></div><div class="snl-price-slider__fill"></div>' +
        '<input type="range" class="snl-price-slider__range snl-price-slider__range--min" min="0" max="' + ceil + '" step="1" aria-label="Minimum price">' +
        '<input type="range" class="snl-price-slider__range snl-price-slider__range--max" min="0" max="' + ceil + '" step="1" aria-label="Maximum price">';
      priceEl.insertBefore(wrap, priceEl.firstChild);

      var rMin = wrap.querySelector('.snl-price-slider__range--min');
      var rMax = wrap.querySelector('.snl-price-slider__range--max');
      var fill = wrap.querySelector('.snl-price-slider__fill');

      function paint() {
        var a = Math.min(+rMin.value, +rMax.value);
        var b = Math.max(+rMin.value, +rMax.value);
        fill.style.left = (a / ceil * 100) + '%';
        fill.style.width = ((b - a) / ceil * 100) + '%';
      }
      function clamp(which) {
        if (+rMin.value > +rMax.value) {
          if (which === 'min') { rMin.value = rMax.value; } else { rMax.value = rMin.value; }
        }
      }
      // Pull the knob positions from the (authoritative) number fields.
      function sync() {
        var mn = num(minInput.value);
        var mx = maxInput.value === '' ? ceil : num(maxInput.value);
        rMin.value = mn == null ? 0 : mn;
        rMax.value = mx == null ? ceil : mx;
        paint();
      }

      rMin.addEventListener('input', function () {
        clamp('min');
        minInput.value = +rMin.value === 0 ? '' : +rMin.value;
        paint();
      });
      rMax.addEventListener('input', function () {
        clamp('max');
        maxInput.value = +rMax.value === ceil ? '' : +rMax.value;
        paint();
      });
      rMin.addEventListener('change', function () {
        minInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      rMax.addEventListener('change', function () {
        maxInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      minInput.addEventListener('input', function () {
        var v = num(minInput.value);
        rMin.value = v == null ? 0 : v;
        clamp('min');
        paint();
      });
      maxInput.addEventListener('input', function () {
        var v = maxInput.value === '' ? ceil : num(maxInput.value);
        rMax.value = v == null ? ceil : v;
        clamp('max');
        paint();
      });

      wrap.__min = minInput;
      wrap.__max = maxInput;
      wrap.__sync = sync;
      sync();
    }

    function initSlider(priceEl) {
      var inputs = priceEl.querySelectorAll('.field__input');
      if (inputs.length < 2) return;
      var minInput = inputs[0];
      var maxInput = inputs[1];
      var existing = priceEl.querySelector('.snl-price-slider');
      // Same fields still present (Dawn morphed values) → just resync the knobs.
      if (existing && existing.__min === minInput && existing.__max === maxInput) {
        existing.__sync();
        return;
      }
      // Fields were replaced by an AJAX re-render (or none yet) → rebuild fresh.
      if (existing) existing.remove();
      build(priceEl, minInput, maxInput);
    }

    // Disconnect while we mutate so our own DOM writes never re-trigger the observer.
    function scan() {
      if (observer) observer.disconnect();
      document.querySelectorAll('.snl-sidebar .facets__price').forEach(initSlider);
      if (observer && root) observer.observe(root, { childList: true, subtree: true });
    }
    function boot() {
      root = document.querySelector('.snl-collection');
      if ('MutationObserver' in window && root) observer = new MutationObserver(scan);
      scan();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snl-quote-body"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Keep the hidden "Requested products" field in sync with the editable list.
    document.querySelectorAll('.snl-quote-body').forEach(function (root) {
      var list = root.querySelector('[data-snl-quote-products]');
      var summary = root.querySelector('[data-snl-quote-summary]');
      var qtyTotalField = root.querySelector('[data-snl-quote-qty]');
      function syncSummary() {
        if (!list || !summary) return;
        var lines = [];
        var total = 0;
        list.querySelectorAll('.snl-quote__product').forEach(function (row) {
          var title = row.getAttribute('data-title');
          var qty = row.querySelector('.snl-quote-stepper__input');
          var n = qty ? parseInt(qty.value, 10) || 0 : 0;
          total += n;
          lines.push(title + ' × ' + (qty ? qty.value : '1'));
        });
        summary.value = lines.join('\n');
        // Quantity is derived from the list, so it can never contradict it.
        if (qtyTotalField && qtyTotalField.hasAttribute('readonly')) qtyTotalField.value = total;
      }
      if (list) {
        list.addEventListener('click', function (e) {
          var btn = e.target.closest('.snl-quote-stepper__btn');
          if (!btn) return;
          var input = btn.parentNode.querySelector('.snl-quote-stepper__input');
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.step, 10));
          input.value = v;
          syncSummary();
        });
        list.addEventListener('input', function (e) {
          if (e.target.classList.contains('snl-quote-stepper__input')) syncSummary();
        });
        syncSummary();
      }

      // Reactive validation (mirrors the trade form).
      var form = root.querySelector('form.snl-quote__form');
      if (!form) return;
      var fields = Array.prototype.slice.call(form.querySelectorAll('.snl-field__input'));
      function messageFor(el) {
        var v = el.value.trim();
        if (el.hasAttribute('required') && !v) return 'This field is required.';
        if (el.type === 'email' && v && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) return 'Enter a valid email address.';
        if (el.hasAttribute('data-snl-abn') && v && v.replace(/\D/g, '').length !== 11) return 'Enter a valid 11-digit ABN (11 digits).';
        return '';
      }
      function errorEl(el) {
        var field = el.closest('.snl-field');
        var e = field.querySelector('.snl-field__error');
        if (!e) { e = document.createElement('small'); e.className = 'snl-field__error'; e.setAttribute('role', 'status'); field.appendChild(e); }
        return e;
      }
      function validate(el) {
        var msg = messageFor(el);
        el.setAttribute('aria-invalid', msg ? 'true' : 'false');
        var e = errorEl(el); e.textContent = msg; e.hidden = !msg;
        return !msg;
      }
      fields.forEach(function (el) {
        el.addEventListener('blur', function () { validate(el); });
        el.addEventListener('input', function () { if (el.getAttribute('aria-invalid') === 'true' || el.hasAttribute('data-snl-abn')) validate(el); });
      });
      // ---- HubSpot submission ---------------------------------------------
      var fieldsPanel = root.querySelector('[data-snl-quote-fields]');
      var successBox = root.querySelector('[data-snl-quote-success]');
      var errorBox = root.querySelector('[data-snl-quote-error]');
      var submitBtn = root.querySelector('[data-snl-quote-submit]');
      var submitLabel = submitBtn ? submitBtn.textContent.trim() : 'Submit Request';
      // Guards against a second request being created by an impatient double click.
      var isSubmitting = false;

      function val(sel) {
        var el = root.querySelector(sel);
        return el ? el.value.trim() : '';
      }

      // Only seven properties exist on the HubSpot form, so everything else the
      // quote asks for is carried in the message instead of being dropped.
      function buildMessage() {
        var lines = ['Project quote request (SNL Request a Quote page).'];
        [
          ['Project name', '#SnlQuoteProject'],
          ['Required date', '#SnlQuoteDate'],
          ['Delivery', '#SnlQuoteDelivery'],
          ['Delivery location', '#SnlQuoteLocation'],
          ['ABN', '#SnlQuoteAbn'],
        ].forEach(function (pair) {
          var v = val(pair[1]);
          if (v) lines.push(pair[0] + ': ' + v);
        });
        if (summary && summary.value) lines.push('', 'Requested products:', summary.value);
        var notes = val('#SnlQuoteNotes');
        if (notes) lines.push('', 'Notes:', notes);
        return lines.join('\n');
      }

      function showError(text) {
        if (!errorBox) return;
        errorBox.hidden = false;
        errorBox.textContent = text;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        // Set synchronously, before any await, so a second click during the
        // in-flight request cannot open a second request.
        if (isSubmitting) return;
        var ok = true;
        fields.forEach(function (el) { if (!validate(el)) ok = false; });
        if (!ok) { var bad = form.querySelector('[aria-invalid="true"]'); if (bad) bad.focus(); return; }

        if (!window.snlHubSpotSubmit) {
          showError("Sorry — the request form couldn't load. Please reload the page and try again.");
          return;
        }
        isSubmitting = true;
        if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }

        var name = window.snlHubSpotSplitName(val('#SnlQuoteName'));
        // One-line product summary; the full list also rides in the message.
        var products = summary && summary.value
          ? summary.value.split('\n').filter(Boolean).join('; ')
          : '';
        // HubSpot's Quantity is a number property.
        var qty = val('[data-snl-quote-qty]').replace(/[^0-9]/g, '');

        window
          .snlHubSpotSubmit({
            firstname: name.firstname,
            lastname: name.lastname,
            company: val('#SnlQuoteCompany'),
            email: val('#SnlQuoteEmail'),
            phone: val('#SnlQuotePhone'),
            product: products,
            quantity: qty,
            project_size: val('#SnlQuoteProjectSize'),
            message: buildMessage(),
          }, 'quote')
          .then(function () {
            if (fieldsPanel) fieldsPanel.hidden = true;
            if (successBox) successBox.hidden = false;
            form.reset();
            if (successBox && successBox.scrollIntoView) {
              successBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          })
          .catch(function (err) {
            isSubmitting = false;
            showError(
              "Sorry — we couldn't send your request (" +
                (err && err.message ? err.message : 'network error') +
                '). Please try again, or call us on the number in the panel and we\'ll take the details.'
            );
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitLabel; }
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snl-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      const KEY = 'snl:recently-viewed';
      let handles = [];
      try {
        handles = JSON.parse(localStorage.getItem(KEY) || '[]');
      } catch (e) {
        handles = [];
      }
      if (!Array.isArray(handles) || handles.length === 0) return;

      const limit = parseInt(this.getAttribute('data-limit'), 10) || 4;
      const grid = this.querySelector('.snl-rv__grid');
      if (!grid) return;

      let shown = 0;
      handles.forEach((handle) => {
        if (shown >= limit) return;
        const item = this.querySelector('[data-snl-rv-handle="' + CSS.escape(handle) + '"]');
        if (item) {
          item.hidden = false;
          grid.appendChild(item); // reorder to recency order
          shown += 1;
        }
      });

      if (shown > 0) this.hidden = false;
    }
  }
  if (!customElements.get('recently-viewed')) {
    customElements.define('recently-viewed', RecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snl-trade-form"] && !Shopify.designMode) return;
  try {
    
  // Reactive validation: each field validates on blur and re-validates live on
  // input once it has been touched, with an inline error message. Submit is the
  // final gate. Degrades gracefully to a normal contact-form post without JS.
  document.querySelectorAll('form.snl-trade-form__form').forEach(function (form) {
    var fields = Array.prototype.slice.call(form.querySelectorAll('.snl-field__input'));

    function messageFor(el) {
      var v = el.value.trim();
      if (el.hasAttribute('required') && !v) return 'This field is required.';
      if (el.type === 'email' && v && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) return 'Enter a valid email address.';
      if (el.hasAttribute('data-snl-abn') && v && v.replace(/\D/g, '').length !== 11) return 'Enter a valid 11-digit ABN (11 digits).';
      return '';
    }

    function errorEl(el) {
      var field = el.closest('.snl-field');
      var e = field.querySelector('.snl-field__error');
      if (!e) {
        e = document.createElement('small');
        e.className = 'snl-field__error';
        e.setAttribute('role', 'status');
        field.appendChild(e);
      }
      return e;
    }

    function validate(el) {
      var msg = messageFor(el);
      var e = errorEl(el);
      el.setAttribute('aria-invalid', msg ? 'true' : 'false');
      e.textContent = msg;
      e.hidden = !msg;
      return !msg;
    }

    fields.forEach(function (el) {
      el.addEventListener('blur', function () { validate(el); });
      el.addEventListener('input', function () {
        // live feedback once touched (or immediately for the ABN field)
        if (el.getAttribute('aria-invalid') === 'true' || el.hasAttribute('data-snl-abn')) validate(el);
      });
    });

    form.addEventListener('submit', function (e) {
      var ok = true;
      fields.forEach(function (el) { if (!validate(el)) ok = false; });
      if (!ok) {
        e.preventDefault();
        var firstBad = form.querySelector('[aria-invalid="true"]');
        if (firstBad) firstBad.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snl-wishlist"] && !Shopify.designMode) return;
  try {
    
  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.store = window.SNLWishlist;
      this.grid = this.querySelector('[data-snl-wl-grid]');
      this.toolbar = this.querySelector('[data-snl-wl-toolbar]');
      this.banner = this.querySelector('[data-snl-wl-banner]');
      this.empty = this.querySelector('[data-snl-wl-empty]');
      this.countEl = this.querySelector('[data-snl-wl-count]');
      this.countWord = this.querySelector('[data-snl-wl-count-word]');
      this.toast = this.querySelector('[data-snl-wl-toast]');

      this.render();
      this._onChange = this.render.bind(this);
      document.addEventListener('snl:wishlist:change', this._onChange);
      this.addEventListener('click', this.onClick.bind(this));
    }
    disconnectedCallback() { document.removeEventListener('snl:wishlist:change', this._onChange); }

    render() {
      if (!this.store) return;
      var handles = this.store.all();
      var count = 0;
      // hide all, then reveal + reorder saved ones
      this.querySelectorAll('.snl-wishlist__item').forEach(function (li) { li.hidden = true; });
      handles.forEach(function (h) {
        var li = this.querySelector('.snl-wishlist__item[data-snl-wl-handle="' + CSS.escape(h) + '"]');
        if (li) { li.hidden = false; this.grid.appendChild(li); count += 1; }
      }, this);

      if (this.countEl) this.countEl.textContent = count;
      if (this.countWord) this.countWord.textContent = count === 1 ? 'item' : 'items';
      var hasItems = count > 0;
      if (this.toolbar) this.toolbar.hidden = !hasItems;
      if (this.banner) this.banner.hidden = !hasItems;
      if (this.grid) this.grid.hidden = !hasItems;
      if (this.empty) this.empty.hidden = hasItems;
    }

    showToast(msg) {
      if (!this.toast) return;
      this.toast.textContent = msg; this.toast.hidden = false;
      clearTimeout(this._t); this._t = setTimeout(function () { this.toast.hidden = true; }.bind(this), 2600);
    }

    addToCart(variantId, qty) {
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      });
    }

    refreshDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) { window.location = window.routes.cart_url; return; }
      fetch(window.routes.cart_url + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshInner = doc.querySelector('.drawer__inner');
          var curInner = drawer.querySelector('.drawer__inner');
          if (freshInner && curInner) { curInner.replaceWith(freshInner); drawer.classList.remove('is-empty'); }
          if (typeof drawer.open === 'function') drawer.open();
        })
        .catch(function () { window.location = window.routes.cart_url; });
    }

    onClick(e) {
      var self = this;
      var removeBtn = e.target.closest('[data-snl-wl-remove]');
      if (removeBtn) {
        var li = removeBtn.closest('.snl-wishlist__item');
        this.store.remove(li.getAttribute('data-snl-wl-handle'));
        return;
      }
      var moveBtn = e.target.closest('[data-snl-wl-move]');
      if (moveBtn) {
        var li2 = moveBtn.closest('.snl-wishlist__item');
        var vid = moveBtn.getAttribute('data-variant-id');
        moveBtn.disabled = true;
        this.addToCart(vid, 1).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          self.store.remove(li2.getAttribute('data-snl-wl-handle'));
          self.refreshDrawer();
        }).catch(function () { moveBtn.disabled = false; self.showToast('Could not add to cart. Try again.'); });
        return;
      }
      var moveAll = e.target.closest('[data-snl-wl-moveall]');
      if (moveAll) {
        var items = Array.prototype.slice.call(this.querySelectorAll('.snl-wishlist__item:not([hidden])'));
        var adds = items.map(function (li3) {
          var b = li3.querySelector('[data-snl-wl-move]');
          return b && !b.disabled ? self.addToCart(b.getAttribute('data-variant-id'), 1) : Promise.resolve();
        });
        moveAll.disabled = true;
        Promise.all(adds).then(function () {
          items.forEach(function (li4) { self.store.remove(li4.getAttribute('data-snl-wl-handle')); });
          window.location = window.routes.cart_url;
        }).catch(function () { moveAll.disabled = false; self.showToast('Could not move all to cart.'); });
        return;
      }
      var shareBtn = e.target.closest('[data-snl-wl-share]');
      if (shareBtn) {
        var handles = this.store.all();
        if (!handles.length) return;
        var url = window.location.origin + window.location.pathname + '?wishlist=' + handles.map(encodeURIComponent).join(',');
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { self.showToast('Wishlist link copied to clipboard.'); })
            .catch(function () { self.showToast(url); });
        } else { self.showToast(url); }
        return;
      }
    }
  }
  if (!customElements.get('wishlist-page')) customElements.define('wishlist-page', WishlistPage);

  } catch(e) { console.error(e); }
})();
})();
